import React from 'react';

export function CouponsCodeFilter({ filterText, onFilter, onClear }) {
  return (
    <div style={{ position: 'relative', width: '200px' }}>
      <input
        id="coupon-code-search"
        type="text"
        placeholder="Buscar por código"
        className="form-control"
        style={{ width: '100%', paddingRight: '34px' }}
        value={filterText}
        onChange={onFilter}
      />
      {filterText ? (
        <button
          type="button"
          onClick={onClear}
          aria-label="Limpar busca"
          style={{
            position: 'absolute',
            top: '50%',
            right: '8px',
            transform: 'translateY(-50%)',
            background: 'none',
            border: 'none',
            padding: 0,
            fontSize: '0.9rem',
            color: 'inherit',
            cursor: 'pointer',
          }}
        >
          <i className="ki ki-close" style={{ fontSize: '0.7rem' }}></i>
        </button>
      ) : (
        <i
          className="flaticon2-search-1"
          style={{
            position: 'absolute',
            top: '50%',
            right: '12px',
            transform: 'translateY(-50%)',
            fontSize: '0.9rem',
            color: 'inherit',
            pointerEvents: 'none',
          }}
        ></i>
      )}
    </div>
  );
}
